import { scroller } from './smoothScroll';
import { gsap, Power4, Power1, Expo } from 'gsap';
import { DrawSVGPlugin } from 'gsap/all';

gsap.registerEase(Power4);
gsap.registerEase(Expo);
gsap.registerEase(Power1);

gsap.registerPlugin(DrawSVGPlugin);

export default (els) => {
    Array.prototype.forEach.call(els, (el) => {

        //console.log(el)

        const menuButton = document.querySelector('[data-mobile-navigation-button]');
        menuButton.addEventListener('click', clickHandler);

        const closeButton = document.querySelector('[data-mobile-navigation-close-button]');
        closeButton.addEventListener('click', closeHandler);

        const logoMark = el.querySelector('[data-logo-mark]');
        const logoMarkPath = el.querySelector('#gridsource-mark');
        //console.log(logoMarkPath)

        const navGroup = el.querySelector('nav');

        let menuStatus = document.body;


        const timeline = gsap.timeline({
            paused: true, onComplete: () => {
                menuStatus.dataset.menu = 'open';
            },
            onReverseComplete: () => {
                menuStatus.dataset.menu = 'closed'
            }
        });

        gsap.set(logoMark, { transformOrigin: 'center center' });

        timeline.to(el, {
            clipPath: 'polygon(50% 100%, 0 100%, 0 0%, 100% 0%, 100% 100%)',
            duration: 1,
            ease: Power1.easeInOut
        });

        timeline.from(logoMark, {
            scale: 0.85,
            duration: 1.5,
            ease: Power4.easeOut
        }, 0);

        timeline.from(logoMarkPath, {
            drawSVG: 0,
            duration: 1
        }, 0);

        timeline.from(navGroup, {
            autoAlpha: 0,
            duration: 1,
            ease: Power4.easeOut
        }, 0.5);

        function clickHandler() {

            if (menuStatus.dataset.menu == 'closed')
                timeline.play();

        }

        function closeHandler() {
            if (menuStatus.dataset.menu == 'open')
                timeline.reverse();
        }




    });
};
